export default {
	'params': {
		'name': 'en',
		'code': 'en',
	},
	'errTitle': '404 Not Found',
	'needSomeHelpWithSymbol': 'Need some help?',
	'getInTouch': 'Get in touch',
	'madeBy': 'Made by',
	'home': 'Homepage',
	'aboutUs': 'About us',
	'products': 'Products',
	'benefits': 'Benefits',
	'recipes': 'Recipes',
	'blog': 'Blog',
	'termsOfUse': 'Terms of use',
	'privacyPolicy': 'Privacy policy',
	'contactUs': 'Contact us',
	'menu': 'Menu',
	'close': 'Close',
	'en': 'En',
	'it': 'It',
	'zh': 'Zh',
	'faq': 'FAQ',
	'showMore': 'Show more',
	'moreDetail': 'More detail',
	'viewAll': 'View all',
	'lastBlogs': 'Latest blogs',
	'filterBy': 'Filter by',

	'byMeal': 'By meal',
	'byDietaryNeeds': 'By dietary needs',
	'byIngredients': 'By ingredients',
	'difficulty': 'Difficulty',
	'byProducts': 'By products',
	'recipesWith': 'Recipes with',
	'our': 'Our',
	'apply': 'Apply',
	'clearAll': 'Clear all',
	'clearAllFilter': 'Clear all filter',
	'noFilterData': 'Sorry, no recipes found',

	'orders': 'Orders',
	'shipping': 'Shipping',
	'marketing': 'Marketing',
	'product': 'Product',

	'fullName': 'Full Name',
	'email': 'Email',
	'message': 'Message',
	'successText': 'Hooray! Your form has successfully zoomed into the digital universe!',
	'send': 'Send',
	'selectSubject': 'Select a subject',

	'buyOnline': 'Buy online',
	'composition': 'Composition',
	'color': 'Color',
	'foodPairings': 'Food pairings',
	'nosen': 'Nose',

	'ingredients': 'Ingredients',
	'servesWithSymbol': 'Serves:',
	'watchHowTo': 'Watch how to',
	'make': 'make',
	'shareWithSymbol': 'Share:',
	'learnMore': 'Learn more',
	'cookingWithOur': 'Cooking with our',
	'oliveOil': 'olive oil',
	'allRecipes': 'All recipes',
	'craftedWith': 'Crafted with',
	'ora': 'Ora',
	'oraBlend': 'Ora Blend',
	'ourProducts': 'Our Products',
	'opinion': 'opinion',
	'peoples': 'People',

	'404title': 'Page not found',
	'404description': 'There’s something not quite right here. No worries, just head back home.',
	'goToHomepage': 'Return to homepage',

	'defaultError': 'Error',

	'orderOutside': 'If you want to order,',
};
